import { useStudio } from '../studios/StudioContext';
import './demoBanner.css';

// Sticky strip shown on every page of a studio whose config has flags.demoBanner.
// Hidden inside embeds so the florium.live page can show the calendar cleanly.
export default function DemoBanner() {
  const studio = useStudio();
  if (typeof window !== 'undefined' && /\/embed$/.test(window.location.pathname)) return null;
  const logins = studio?.demoLogins ?? [];
  const id = studio?.studioId ?? 'demo';

  return (
    <div className="demo-banner" role="note">
      <div className="demo-banner__main">
        <span className="demo-banner__icon" aria-hidden="true">🧪</span>
        <strong>This is the Florium demo.</strong>
        <span className="demo-banner__note">
          Nothing is real: no emails are sent and payments use Stripe test mode (card 4242 4242 4242 4242). Resets nightly.
        </span>
      </div>
      <div className="demo-banner__actions">
        {logins.map(l => (
          <span key={l.role} className="demo-banner__pw">
            {l.role}: <code>{l.email}</code> / <code>{l.password}</code>
          </span>
        ))}
        <a href={`/${id}/admin`} className="demo-banner__link">Admin →</a>
        <a href="https://florium.live" className="demo-banner__link" target="_blank" rel="noopener noreferrer">About Florium →</a>
      </div>
    </div>
  );
}
